module.exports = __webpack_public_path__ + "img/logo-(1).06b7fe20.png";